<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【我的预约】</span>按钮</p>
        <img src="../../../assets/userImg/updateAppoint_a.png" alt="">
        <p><strong>第二步：</strong>在【预约列表】中，找到需要取消的预约，点击<span class="orange">【取消预约】</span>的按钮，弹出【取消预约】确认弹窗
        </p>
        <img src="../../../assets/userImg/cancel_b.png" alt="">
        <p><strong>第三步：</strong>在【取消预约】弹窗中，填写取消的原因，点击<span class="orange">【仍要取消】</span>
        </p>
        <p class="orange">注：经平台确认取消成功之后，咨询费用将退回原支付账户</p>
        <img src="../../../assets/userImg/cancel_c.png" alt="" width="700">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【预约列表】中点击<span class="orange">【查看详情】</span>按钮</p>
          <p><strong>第二步：</strong>在【预约详情】中点击<span class="orange">【取消预约】</span>按钮</p>
          <p><strong>第三步：</strong>填写取消的原因，点击<span class="orange">【仍要取消】</span></p>
        </div>
        <img src="../../../assets/userImg/cancelPhone.png" alt="">
        <p class="orange">【注】经平台确认取消成功之后，咨询费用将退回原支付账户</p>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "cancelAppoint",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
